// components/landingPage/Features.jsx
import React from 'react';

const Features = () => {
  const features = [
    {
      icon: "🔄",
      title: "Waste to Revenue",
      description: "Transform potential waste into profitable sales with our intelligent marketplace"
    },
    {
      icon: "📊",
      title: "Real-time Analytics",
      description: "Monitor your climate impact, revenue, and waste reduction in real-time"
    },
    {
      icon: "🤖",
      title: "AI Insights",
      description: "Get smart recommendations for pricing, promotions, and inventory management"
    },
    {
      icon: "🚚",
      title: "Order Management",
      description: "Streamline your order processing with integrated tracking and communication"
    },
    {
      icon: "🌱",
      title: "Climate Impact",
      description: "Track and showcase your contribution to reducing food waste emissions"
    },
    {
      icon: "💬",
      title: "Direct Communication",
      description: "Connect directly with buyers through integrated WhatsApp messaging"
    }
  ];

  return (
    <section className="py-20 bg-white px-4">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-4xl font-bold text-center text-gray-900 mb-4">
          Everything You Need to Succeed
        </h2>
        <p className="text-xl text-center text-gray-600 mb-12 max-w-2xl mx-auto">
          Our platform provides all the tools to efficiently manage your agribusiness while making a positive environmental impact
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-6 shadow-lg border border-gray-100 hover:shadow-xl transition-all duration-300 hover:translate-y-[-4px]">
              <div className="text-3xl mb-4">{feature.icon}</div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{feature.title}</h3>
              <p className="text-gray-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;